import { AppAreaConfig } from '@/funnels/@types'
import fastingFemale from '../fasting/female'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-ramadan-fwf',
	landing: {
		ids: ['loader-f-ramadan'],
		route: {
			path: '/ramadan-f',
			name: 'female-ramadan-fwf-funnel',
		},
	},
	funnel: {
		id: 'ob-female-ramadan-fwf',
		route: {
			path: '/ramadan-f/ob/:page*',
			name: 'female-ramadan-fwf',
		},
		slug: 'female-ramadan-fwf',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: fastingFemale,
				page: 'how-do-you-sleep',
			},
		},
	},
}

export default appAreaConfig
